import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useFormModalStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            padding: theme.spacing(2),
            // paddingBottom: theme.spacing(÷),
            width: "100%",
            marginBottom: theme.spacing(2)
        },
        paperstepper: {
            width: "100%",
            marginTop: theme.spacing(1)
        },
        formcontainer: {
            display: "flex",
            flexWrap: "wrap",
            width: "100%"
        },
        textField: {
            marginRight: theme.spacing(1),
            width: "100%"
        },
        dense: {
            marginTop: 19
        },
        menu: {
            width: 200
        },
        button: {
            marginTop: theme.spacing(2),
            marginRigh: theme.spacing(0),
            margin: theme.spacing(1)
        },
        mainTitle: {
            marginBottom: theme.spacing(1)
        },
        helpForm: {
            marginBottom: theme.spacing(1)
        }
    })
);

export default useFormModalStyles;
